import { useState } from 'react';
import { Link } from 'react-router-dom';

import { getApiErrorMessage, requestPasswordReset } from '../api/api';
import '../styles/global.css';


export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      const result = await requestPasswordReset(email.trim());
      setSuccess(
        result?.detail ||
          'Enviamos um link para redefinir sua senha. Verifique sua caixa de entrada.'
      );
    } catch (requestError) {
      setError(
        getApiErrorMessage(
          requestError,
          'Não foi possível solicitar a recuperação de senha. Tente novamente.'
        )
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-form" onSubmit={handleSubmit}>
        <img src="/logo.png" alt="Logo BlueZap" className="logo-imagem" />
        <h2>Esqueci minha senha</h2>
        <p className="auth-form-intro">
          Informe o e-mail cadastrado no BlueZap. Enviaremos um link válido por 10 minutos.
        </p>

        <input
          id="forgot-password-email"
          name="email"
          type="email"
          placeholder="E-mail"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          autoComplete="email"
          required
          disabled={loading}
        />

        <button className="auth-form-submit" type="submit" disabled={loading}>
          {loading ? 'Enviando...' : 'Enviar link de recuperação'}
        </button>

        {success ? (
          <p className="auth-form-message auth-form-message--success" role="status">
            {success}
          </p>
        ) : null}
        {error ? (
          <p className="auth-form-message auth-form-message--error" role="alert">
            {error}
          </p>
        ) : null}

        <Link className="auth-form-link" to="/login">
          Voltar para o login
        </Link>
      </form>
    </div>
  );
}
